import React from 'react';
import JavascriptLoops from './JavascriptLoops.jsx';
import JavascriptLoopsFor from './JavascriptLoopsFor.jsx';
import JavascriptLoopsWhile from './JavascriptLoopsWhile.jsx';
import JavascriptLoopsForIn from './JavascriptLoopsForIn.jsx';
import JavascriptLoopsForOf from './JavascriptLoopsForOf.jsx';
import JavascriptIterables from './JavascriptIterables.jsx';
import JavascriptIterators from './JavascriptIterators.jsx';
import JavascriptGenerators from './JavascriptGenerators.jsx';

export default function JsIterations() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Iterations</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/loops' className='underline'>JS Loops</a></li>
<li><a href='/javascript/loops/for' className='underline'>JS Loop for</a></li>
<li><a href='/javascript/loops/while' className='underline'>JS Loop while</a></li>
<li><a href='/javascript/loops/for-in' className='underline'>JS Loop for...in</a></li>
<li><a href='/javascript/loops/for-of' className='underline'>JS Loop for...of</a></li>
<li><a href='/javascript/iterables' className='underline'>JS Iterables</a></li>
<li><a href='/javascript/iterators' className='underline'>JS Iterators</a></li>
<li><a href='/javascript/generators' className='underline'>JS Generators</a></li>
      </ul>
    </div>
  );
}
